export default __webpack_public_path__ + "static/media/icon-add.8ff98476.svg";